import { PartnerModel } from './partner.model';
import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { CompetenceModel } from './competence.model';

export class OnlinetestModel extends BaseModel implements Deserializable {

  // columns
  name: string;
  public_name: string;
  with_observers: boolean;
  with_behavioranchors: boolean;

  for_ac: boolean;
  for_toolbox: boolean;
  candidate_comment: string;
  api_active: boolean;

  // relations
  partner: PartnerModel;
  competences: Array<CompetenceModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // partner
    if (this.partner !== null && this.partner !== undefined) {
      this.partner = new PartnerModel().deserialize(this.partner);
    }
    // competences
    let competences = null;
    if (this.competences !== null && this.competences !== undefined) {
      competences = [];
      this.competences.forEach((competence: CompetenceModel) => {
        competences.push(new CompetenceModel().deserialize(competence));
      });
    }
    this.competences = competences;
    this.loaded = true;
    return this;
  }

  get fullname(): string {
    return this.partner?.name + ' / ' + this.name;
  }

}
